import React from 'react';
import { Route, IndexRedirect, Redirect } from 'react-router';
import Setting from './screens/Setting/router';
import MyTeams from './screens/MyTeams/router';
import MyData from './screens/MyData/router';
import PA from './screens/PA/router';
import Hire from './screens/Hire/router';
import Preview from './screens/Preview/router';
import Report from './screens/Report/router';
import FilePreview from './screens/FilePreview/router';
import EnsureLoggedIn from 'containers/App/components/EnsureLoggedIn/';
import Layout from 'containers/App/components/Layout/';

export default (
  <Route component={Layout}>
    <Route component={EnsureLoggedIn}>
      <Route path="foundation" crumbName="Foundation"
        getComponent={(Location, cb) => {
          require.ensure([], (require) => {
            cb(null, require('./index'));
          });
        }}
      >
        {PA}
        {MyTeams}
        {MyData}
        {Setting}
        {Hire}
        {Preview}
        {Report}
        {FilePreview}
        <IndexRedirect to="mydata" />
        <Redirect from="*" to="mydata" />
      </Route>
    </Route>
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/router.js
 **/